import { getQuery } from '@/common/const';
import { getAppProps } from '@/AppProps';
import { reportCatchError } from '@/utils/reportCatchError';
import queryString from 'query-string';
import { BUNDLE_ID_LIST, SCENE } from '../const';

const getInfoFromUrl = (url: string) => {
    const parseUrl = queryString.parseUrl(url);
    const redirectUrl2 = queryString.parse(parseUrl?.query?.redirectUrl as string);
    const targetBundleId = redirectUrl2.bundleId as string; // 目标 Bundle
    const bundleId = getAppProps()?.bundleId; // 当前 BundleId
    return {
        targetBundleId,
        bundleId,
    };
};

// 处理特定场景的 Scene 值
export const addSceneToUrl = (url: string) => {
    try {
        const { bundleId, targetBundleId } = getInfoFromUrl(url);
        const scene = getQuery('scene');
        if (!bundleId || !targetBundleId) return url;

        // 购物车跳商详、提单，scene = 12
        if (BUNDLE_ID_LIST.MyShoppingCar === bundleId && [BUNDLE_ID_LIST.DETAIL, BUNDLE_ID_LIST.EcommOrderConfirm.includes(targetBundleId)]) {
            return queryString.stringifyUrl({
                url,
                query: {
                    scene: SCENE.SHOP_CART_SKU,
                },
            });
        }

        if (scene) {
            return queryString.stringifyUrl({
                url,
                query: {
                    scene,
                },
            });
        }

        return url;
    } catch (e) {
        reportCatchError(e, {
            position: 'addSceneToUrl',
            message: e.message,
            extra: {
                url,
            },
        });
        return url;
    }
};

// 跳店铺页，默认走沉浸式 themeStyle = 1
export const addThemeStyleToUrl = (url: string) => {
    try {
        const parseUrl = queryString.parseUrl(url);
        const redirectUrl = queryString.parse(parseUrl?.query?.redirectUrl as string);
        const targetBundleId = redirectUrl.bundleId as string; // 目标 Bundle
        if (['EcommMerchant'].includes(targetBundleId)) {
            redirectUrl.themeStyle = '1';
        }
        return queryString.stringifyUrl({
            url,
            query: {
                redirectUrl: queryString.stringify(redirectUrl),
            },
        });
    } catch (e) {
        reportCatchError(e, {
            position: 'addThemeStyleToUrl',
            message: e.message,
            extra: {
                url,
            },
        });
        return url;
    }
};
